import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import ScrollFadeIn from './../../components/scrollFadeIn';
import {Colors} from './../../utils/variables';
import './stay-with-us.scss';

export default class StayWithUs extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background stay-with-us-page">
        <div className="slant-bottom">
          <Hero
            title={'Stay With Us'}
            backgroundImage={'/images/stay-with-us-hero.jpg'}
            height={'threequarter'}
            tint={''}
          />
        </div>

        <div className="gutter">
          <ScrollFadeIn>
            <div className="medium-max-width-container story-lip lip shadow" style={{color:Colors.white, backgroundColor:Colors.primary}}>
              <div className="large-padding centered-text" style={{backgroundImage:'url(/images/topo-texture.png)'}}>
              <p>{'For 2027 we are offering camping and lodging to match any budget. Whether you prefer sleeping under the stars or resting in a cozy room at the mountain, we have options for every rider. Choose the experience that fits you best.'}</p>
              </div>
            </div>
          </ScrollFadeIn>
          <ScrollFadeIn>
            <div className="medium-max-width-container row stay-option-row">
              <Link to="/camping" className="stay-option-link">
                <div
                  className="stay-option-card stay-option-card--center shadow"
                  style={{ backgroundImage: 'url(/images/camp.jpg)' }}
                >
                  <div className="stay-option-card__content">
                    <h2 className="white stay-option-card__title">{'Camping'}</h2>
                    <p className="white subheading stay-option-card__description">{'Under the stars at Kirkwood'}</p>
                  </div>
                </div>
              </Link>
              <Link to="/lodging" className="stay-option-link">
                <div
                  className="stay-option-card stay-option-card--bottom shadow"
                  style={{ backgroundImage: 'url(/images/landscape.jpg)' }}
                >
                  <div className="stay-option-card__content">
                    <h2 className="white stay-option-card__title">{'Lodging'}</h2>
                    <p className="white subheading stay-option-card__description">{'Mountain Club at Kirkwood'}</p>
                  </div>
                </div>
              </Link>
            </div>
          </ScrollFadeIn>
        </div>
      </div>
    );
  }
}
